import React from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import PlanCard from "@/components/PlanCard";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

const Wishlist = () => {
  const { wishlist } = useApp();

  React.useEffect(() => { document.title = "My Wishlist — Dream Home Plans"; }, []);

  return (
    <Layout>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14 lg:py-20">
        <div className="overline text-accent">Wishlist</div>
        <h1 className="font-display text-5xl lg:text-6xl mt-3 leading-none tracking-tighter">Saved for later.</h1>

        {wishlist.length === 0 ? (
          <div className="text-center py-24 border border-border mt-12" data-testid="empty-wishlist">
            <Heart size={40} className="mx-auto text-accent" />
            <p className="mt-6 text-muted-foreground">Your wishlist is empty. Tap the heart on any plan to save it here.</p>
            <Link to="/plans">
              <Button className="rounded-none bg-primary mt-8 h-12 px-8">Browse plans</Button>
            </Link>
          </div>
        ) : (
          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 lg:gap-8" data-testid="wishlist-grid">
            {wishlist.map((p) => <PlanCard key={p.id} plan={p} />)}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Wishlist;
